import Big from 'big.js';

export const numUtil = {
  floor(num, precision, scale = 0) {
    if (isNaN(num) || num === void 0) {
      return '';
    }
    const side = num < 0 ? -1 : 1;
    return Big(num).abs().times(Big(10).pow(-scale)).round(precision, 0).times(side).toFixed(precision);
  },
  unscale(num, scale = 0) {
    if (isNaN(num) || num === void 0) {
      return '';
    }
    const side = num < 0 ? -1 : 1;
    return toString(Big(num).abs().times(Big(10).pow(-scale)).times(side));
  },
  ceil(num, precision, scale = 0) {
    if (isNaN(num)) {
      return '';
    }
    const side = num < 0 ? -1 : 1;
    return Big(num).abs().times(Big(10).pow(-scale)).round(precision, 3).times(side).toFixed(precision);
  },
  roundPrice(numStr, tickSize, precision, side = 'Sell') {
    if (numStr === '') {
      return numStr;
    }
    const num = Number(numStr);
    if (isNaN(num)) {
      return '';
    }
    const pow = Big(10).pow(precision);
    const x = Big(num).times(pow);
    const y = Big(tickSize).times(pow);
    let times;
    if (side === 'Buy') {
      times = x.div(y).round(0, 3);
    }
    if (side === 'Sell') {
      times = x.div(y).round(0, 0);
    }
    if (times === 0) {
      return String(tickSize);
    }
    return Big(times).times(tickSize).toFixed(precision);
  },
  delimit(value) {
    const amount = String(value);
    let regexp = '(\\d)(?=(\\d{3})+\\.)';
    if (amount.indexOf('.') < 0) {
      regexp = '(\\d)(?=(\\d{3})+$)';
    }
    return amount.replace(new RegExp(regexp, 'g'), '$1,');
  },
  pad(num) {
    return (num < 10 ? '0' : '') + String(num);
  },
  parseFloat(num, precision, scale = 0) {
    if (isNaN(num)) {
      return '';
    }
    const side = num < 0 ? -1 : 1;
    const returnNum = Big(num).abs().times(Big(10).pow(-scale)).round(precision, 0).times(side).toFixed(precision);
    return parseFloat(returnNum);
  },
  abbreviateNumber(num) {
    const str = num.toString();
    if (String(Math.abs(parseInt(num))).length <= 3) {
      return str;
    }

    const items = [
      {number: 1e3, unit: 'K'},
      {number: 1e6, unit: 'M'},
      {number: 1e9, unit: 'B'},
      {number: 1e12, unit: 'T'},
      {number: 1e15, unit: 'P'},
      {number: 1e18, unit: 'E'},
    ];

    let index;
    for (index = items.length - 1; index > 0; index--) {
      if (num >= items[index].number) {
        break;
      }
    }
    const item = items[index];
    if (!item) {
      return str;
    }
    const {number, unit} = item;
    return this.floor((num / number).toString().replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1'), 2) + unit;
  },
  abbreviatePulseNumber(num) {
    if (num === 0) {
      return num;
    }
    const str = num.toString();
    if (String(Math.abs(parseInt(num))).length <= 6) {
      return this.delimit(num);
    }

    const items = [
      {number: 1e6, unit: 'M+'},
      {number: 1e9, unit: 'B+'},
    ];

    let index;
    for (index = items.length - 1; index > 0; index--) {
      if (num >= items[index].number) {
        break;
      }
    }
    const item = items[index];
    if (!item) {
      return str;
    }
    const {number, unit} = item;
    return this.trimEnd0(this.floor((num / number).toString().replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1'), 2)) + unit;
  },
  unAbbreviateNumber(num) {
    const map = {K: 1e3, M: 1e6, B: 1e9, T: 1e12, P: 1e15, E: 1e18};
    const realNum = ('' + num).replace(/,/g, '');
    const key = Object.keys(map).find((o) => realNum.endsWith(o));
    if (key) {
      return parseFloat(realNum.slice(0, -1)) * map[key];
    }
    return parseFloat(realNum);
  },
  trimEnd0(str) {
    const segments = str.split('.');
    if (segments.length < 1) {
      return str;
    }

    if (segments.length < 2) {
      return str;
    }

    const integer = segments[0];
    const decimal = segments[1].replace(/0+$/, '');
    if (decimal === '') {
      return integer;
    }

    return [integer, decimal].join('.');
  },
  startWithNumber(str) {
    return /^\d/.test(str);
  },
  isNumber(str) {
    return /^\d+$/.test(str);
  },
  isEmpty(value) {
    return [null, undefined, ''].includes(value);
  },
  parseInt(str) {
    const map = {K: 1e3, M: 1e6, B: 1e9, T: 1e12, P: 1e15, E: 1e18};
    const key = Object.keys(map).find((o) => str.endsWith(o));
    if (key) {
      return parseInt(str.slice(0, -1)) * map[key];
    }
    return parseInt(str);
  },

  /**
   * 2个数字之间的大小比较
   * @param {*} a 第一个比较的数字
   * @param {*} b 第二个比较的数字
   * @param {*} symbol 比较符号(<, <=, >, >=, =)
   * @returns
   */
  compare(a, b, symbol) {
    const strategies = {
      '>': (a, b) => a.gt(b),
      '=': (a, b) => a.eq(b),
      '>=': (a, b) => a.gte(b),
      '<': (a, b) => a.lt(b),
      '<=': (a, b) => a.lte(b),
    };
    const calc = strategies[symbol];
    if (calc) {
      try {
        return calc(new Big(a || '0'), new Big(b || '0'));
      } catch (error) {}
    }
    return false;
  },
  // 科学记数法转数字
  getFullNum(num) {
    //处理非数字
    if (isNaN(num)) {
      return num;
    }

    //处理不需要转换的数字
    const str = '' + num;
    if (!/e/i.test(str)) {
      return num;
    }

    return num.toFixed(18).replace(/\.?0+$/, '');
  },
  //序数词
  ordinalNumber(number) {
    const index = number % 10;
    const suffix = ['th', 'st', 'nd', 'rd'];
    return `${number}${suffix[index] || suffix[0]}`;
  },
};

/**
 * 将 BigSource 类型数据转为字符串。（Big.js 的 toString 会产生科学计数法数字字符串）
 * @param {BigSource} value
 * @returns string
 */
export function toString(value) {
  const str = Big(value).abs().toString();
  // 单位（正/负）
  const side = Big(value).gte(0) ? '' : '-';
  if (!/e/.test(str)) {
    return side + str;
  }

  // 指数
  const index = Number(str.match(/\d+$/)[0]);
  // 基数
  const basis = str.match(/^[\d\.]+/)[0].replace(/\./, '');

  if (/e-/.test(str)) {
    return side + basis.padStart(index + basis.length, '0').replace(/^0/, '0.');
  }

  if (basis.length < index) {
    return side + basis.padEnd(index + 1, '0');
  }

  const integerPart = basis.substring(0, index + 1);
  const decimalPart = basis.substring(index + 1);

  if (decimalPart) {
    return side + integerPart + '.' + decimalPart;
  }

  return side + integerPart;
}

export {div as divided};

// /**
//  * Math.abs(number)
//  * @param {BigSource} value
//  */
// export function abs(value) {
//   return toString(Big(value).abs());
// }

/** @typedef { number | string | Big } BigSource */
/** @typedef { import('big.js')['RoundingMode'] } RoundingMode */

export function floor(val, precision = 0) {
  return Number(Big(val).round(precision, Big.roundDown));
}

/**
 * value1 - value2
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function minus(value1, value2) {
  return toString(Big(value1).minus(value2));
}

/**
 * value1 + value2
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function plus(value1, value2) {
  return toString(Big(value1).plus(value2));
}

/**
 * value1 + value2 + ...
 * @param {BigSource[]} values
 * @returns
 */
export function sum(...values) {
  if (values.length < 1) {
    return '0';
  }
  return toString(values.reduce((p, c) => Big(p).plus(c), Big(0)));
}

/**
 * value1 * value2
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function times(value1, value2) {
  return toString(Big(value1).times(value2));
}

/**
 * value1 / value2
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @param {number} precision -1 不截取、0 到 1e+6（含） 保留小数位数。Default value: -1
 * @param {RoundingMode} rm 舍入模式：0（向下）、1（向最近的邻居四舍五入。如果等距，则从零舍入。）、2（向最近的邻居四舍五入。如果等距，则向偶数邻居舍入。）、 3（向上）。Default value: 1
 * @returns
 */
export function div(value1, value2, precision = -1, rm = 1) {
  if (precision === -1) {
    return toString(Big(value1).div(value2));
  }
  return toFixed(Big(value1).div(value2), precision, rm);
}

export function min(value1, ...values) {
  if (values.length === 0) {
    return toString(Big(value1));
  }
  return toString(values.reduce((p, c) => (p.gt(c) ? Big(c) : p), Big(value1)));
}

export function max(value1, ...values) {
  if (values.length === 0) {
    return toString(Big(value1));
  }
  return toString(values.reduce((p, c) => (p.gt(c) ? p : Big(c)), Big(value1)));
}

/**
 * value1 > value2 => true
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function gt(value1, value2) {
  return Big(value1).gt(value2);
}

/**
 * value1 >= value2 => true
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function gte(value1, value2) {
  return Big(value1).gte(value2);
}

/**
 * value1 < value2 => true
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function lt(value1, value2) {
  return Big(value1).lt(value2);
}

/**
 * value1 <= value2 => true
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function lte(value1, value2) {
  return Big(value1).lte(value2);
}

/**
 * Big(value1) === Big(value2) => true
 * @param {BigSource} value1
 * @param {BigSource} value2
 * @returns
 */
export function eq(value1, value2) {
  return Big(value1).eq(value2);
}

/**
 * Math.pow(10).(exp)
 * @param {BigSource} exp
 * @param {boolean} isToString
 * @returns {Big | string}
 */
export function pow10(exp, isToString = false) {
  const res = Big(10).pow(Number(Big(exp).toString()));
  if (isToString) {
    return toString(res);
  }
  return res;
}

/**
 * @param {BigSource} value
 * @param {number} precision 小数位数，0 到 1e+6（含）
 * @param {RoundingMode} rm 舍入模式：0（向下）、1（向最近的邻居四舍五入。如果等距，则从零舍入。）、2（向最近的邻居四舍五入。如果等距，则向偶数邻居舍入。）、 3（向上）。Default value: 1
 * @returns
 */
export function toFixed(value, precision = 8, rm = 1) {
  return Big(value).round(precision, rm).toFixed(precision);
}

/**
 * Math.abs(number)
 * @param {BigSource} value
 */
export function abs(value) {
  return toString(Big(value).abs());
}

// 千分位转换
export function formatToThousand(num) {
  if (num || num === 0) {
    const [int, fraction] = num.toString().split('.');
    return int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (!!fraction ? '.' + fraction : '');
  }
  return undefined;
}
